import Styles from 'src/components/Styles';
import {
  StyleSheet,
  View,
  Text,
  Platform,
  PixelRatio,
  Dimensions,
} from 'react-native';
import {
  CustomTilesButtonStylesDescriptor,
  ProductModifierRadioButton,
  CheckoutBarProps,
  PickupLocationListStylesDescriptor,
  RecentOrdersButtonStylesDescriptor,
  ProductModifierStylesDescriptor,
} from 'src/components/elements/orderAhead/descriptor/DescriptorType';
import {checkValue, formatCurrency} from 'src/Util';
import Localized from 'src/constants/AppStrings';
import {ProductModifierValue} from 'src/types/Menu';
import {BarButton} from 'src/components/elements/orderAhead/BarButton';
import CartImage from 'src/components/img/svg/CartImage';
import CustomToggleComponent, {
  CustomToggleComponentType,
} from 'src/components/elements/CustomToggleComponent';
import AccountStore from 'src/stores/AccountStore';

const screenWidth = Dimensions.get('window').width;

export function customTilesButtonStyles(): CustomTilesButtonStylesDescriptor {
  return StyleSheet.create({
    text: {
      fontSize: Styles.Fonts.f7,
      paddingHorizontal: Styles.Spacing.m2,
      color: Styles.Colors.CompanyKitchen.black,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.latoRegular,
    },
    tileConatainer: {
      alignItems: 'center',
      flexDirection: 'row',
      minWidth: 135,
      paddingHorizontal: Styles.Spacing.m2 + 4,
      justifyContent: 'flex-start',
      borderColor: Styles.lightGray,
      borderWidth: 1,
      paddingVertical: Styles.Spacing.m3,
      borderRadius: Styles.Spacing.m2,
      overflow: 'hidden',
    },
    selectedText: {
      fontWeight: '700',
      color: Styles.Colors.CompanyKitchen.black,
    },
    selectedView: {
      borderColor: Styles.Colors.CompanyKitchen.primary,
      backgroundColor: 'rgba(0, 156, 222, 0.15)',
      borderWidth: 2.5,
      paddingVertical: Styles.Spacing.m3 - 1.5,
    },
  });
}

export function pickupLocationListStyles(): PickupLocationListStylesDescriptor {
  return StyleSheet.create({
    cell: {
      alignItems: 'center',
      marginTop: Styles.Spacing.m3,
      borderRadius: Styles.Spacing.m2,
      padding: Styles.Spacing.m3,
      borderColor: Styles.Colors.CompanyKitchen.lightGray,
      borderWidth: 1,
      flexDirection: 'row',
      minHeight: Styles.Heights.touchTargetHeight2,
      overflow: 'hidden',
      backgroundColor: Styles.Colors.PayNew.white01,
    },
    label: {
      color: Styles.Colors.CompanyKitchen.black,
      fontWeight: '400',
      fontSize: Styles.Fonts.f7,
      paddingLeft: Styles.Spacing.m2,
      paddingRight: Styles.Spacing.m4,
      fontFamily: Styles.FontFamily.latoRegular,
      overflow: 'hidden',
    },
    cellSelected: {
      padding: Styles.Spacing.m3,
      borderWidth: 2.5,
      flexDirection: 'row',
      borderColor: Styles.Colors.CompanyKitchen.primary,
      marginTop: Styles.Spacing.m3,
      alignItems: 'center',
      borderRadius: Styles.Spacing.m2,
      backgroundColor: 'rgba(0, 156, 222, 0.15)',
    },
    selectedLabel: {
      color: Styles.Colors.CompanyKitchen.black,
      paddingLeft: Styles.Spacing.m2,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.latoRegular,
      fontSize: Styles.Fonts.f7,
    },
  });
}

export function pickupLocationInnerCircleBackgroundColor(): string {
  return Styles.Colors.CompanyKitchen.primary;
}

export function pickupLocationOuterCircleBorderColor(): string {
  return Styles.Colors.CompanyKitchen.primary;
}

export function productModifierStyles(): ProductModifierStylesDescriptor {
  return StyleSheet.create({
    radioButtonWrapper: {
      backgroundColor: Styles.white,
      padding: Styles.Spacing.m1,
      justifyContent: 'center',
      marginLeft: Styles.Spacing.m0,
    },
    customizationDivider: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      paddingVertical: Styles.Spacing.m1,
      marginLeft: Styles.Spacing.m2,
    },
    checkboxCalorieContainer: {
      alignItems: 'center',
    },
    checkboxNameContainer: {
      flex: 7,
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginRight: Styles.Spacing.m2,
    },
    checkboxRow: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    checkboxPriceContainer: {
      alignItems: 'flex-start',
      flexDirection: 'column',
      flex: 3,
    },
    titleText: {
      fontWeight: '700',
      color: Styles.Colors.PayNew.black01,
      flex: 0.8,
      fontSize: Styles.Fonts.f1,
      fontFamily: Styles.FontFamily.latoRegular,
    },
    requiredViewStyles: {
      flexDirection: 'row',
      flex: 1,
      justifyContent: 'space-between',
      marginTop: Styles.Spacing.m2,
      marginBottom: Styles.Spacing.m2,
    },
    options: {
      paddingVertical: Styles.Spacing.m0,
    },
    requiredText: {
      color: Styles.dangerColor,
      fontSize: Styles.Fonts.f1,
      fontStyle: 'italic',
    },
    totalCaloriesLabel: {
      fontWeight: '400',
      fontSize: Styles.Fonts.f1,
      fontFamily: Styles.FontFamily.latoRegular,
      color: Styles.Colors.PayNew.black01,
    },
    sectionCalStyles: {
      fontWeight: Styles.bold,
      fontSize: Styles.Fonts.f1,
      marginRight: Styles.Spacing.m2,
      color: Styles.darkColor,
    },
    checkBoxWrapper: {
      justifyContent: 'center',
      padding: Styles.Spacing.m1,
      minHeight: Styles.Heights.h3,
      backgroundColor: Styles.white,
      marginLeft: Styles.Spacing.m0,
      margin: null,
    },
    productModifierContainer: {
      marginHorizontal: Styles.Spacing.m3,
    },
    checkBoxText: {
      color: Styles.darkColor,
      marginLeft: Styles.Spacing.m2,
    },
    optionText: {
      fontSize: Styles.Fonts.f0,
      marginTop: -Styles.Spacing.m1 / 2,
      marginLeft: Styles.Spacing.m2,
      color: Styles.darkColor,
      marginBottom: 5,
    },
    titleRow: {
      justifyContent: 'space-between',
      marginTop: Styles.Spacing.m3,
      flexDirection: 'row',
    },
    helperText: {
      fontSize: Styles.Fonts.f8,
      fontFamily: Styles.FontFamily.latoRegular,
      fontWeight: '400',
      color: Styles.Colors.PayNew.darkHuesBase04,
      marginRight: Styles.Spacing.m2,
    },
    freeTextContainer: {maxHeight: 56},
    freeTextContent: {
      paddingTop: Styles.Spacing.m1,
      paddingBottom: Styles.Spacing.m1,
    },
  });
}
export function radioButtonProductModifier(
  buttons: ProductModifierRadioButton[],
  values: string[],
  showCalories: boolean,
  showUnitName: string,
  onPress,
): JSX.Element {
  return (
    <>
      {buttons.map((obj, i) => {
        const isSelected = values.includes(obj.value);
        return (
          <View
            accessible={true}
            accessibilityState={{
              selected: isSelected,
            }}
            key={obj.value + '-' + i}
            style={productModifierStyles().customizationDivider}
            testID="qa_ModifierContainer"
            nativeID="qa_ModifierContainer"
          >
            <View style={{marginTop: 2}}>
              <CustomToggleComponent
                accessibilityLabel={obj.label}
                selected={isSelected}
                type={CustomToggleComponentType.Radio}
                onPress={() => onPress(obj.value)}
                testID="qa_Modifier_radio"
              />
            </View>
            <View style={styles.modifierLeftView}>
              <Text
                accessibilityLabel={`${obj.label}, `}
                aria-label={`${obj.label}, `}
                style={styles.modifierText}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm3}
                accessible
                testID="qa_ModifierName_txt"
                nativeID="qa_ModifierName_txt"
              >
                {obj.label}
              </Text>
              {showCalories && checkValue(obj.calories) && (
                <Text
                  accessibilityLabel={`${
                    obj.calories
                  } ${Localized.Labels.calories.toLowerCase()}`}
                  aria-label={`${
                    obj.calories
                  } ${Localized.Labels.calories.toLowerCase()}`}
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
                  style={styles.priceText}
                  accessible
                  testID="qa_ModifierCal_txt"
                  nativeID="qa_ModifierCal_txt"
                >
                  {`(${obj.calories} ${showUnitName})`}
                </Text>
              )}
            </View>
            <View style={productModifierStyles().checkboxCalorieContainer}>
              {obj.price !== null && (
                <Text
                  accessibilityLabel={`${obj.price}, `}
                  aria-label={`${obj.price}, `}
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm0}
                  style={styles.calorieText}
                  accessible
                  testID="qa_ModifierPrice_txt"
                  nativeID="qa_ModifierPrice_txt"
                >
                  {obj.price}
                </Text>
              )}
            </View>
          </View>
        );
      })}
    </>
  );
}

export function checkboxProductModifiers(
  value: ProductModifierValue,
  price: string,
  calories: string,
  modifierValues: string[],
  showUnitName: string,
  showCalories: boolean,
  onPress,
): JSX.Element {
  return (
    <View
      accessible={true}
      key={value.id}
      style={productModifierStyles().customizationDivider}
      testID="qa_ModifierContainer"
      nativeID="qa_ModifierContainer"
    >
      <View style={{marginTop: 2}}>
        <CustomToggleComponent
          accessibilityLabel={value.name}
          selected={modifierValues.includes(value.id)}
          type={CustomToggleComponentType.Checkbox}
          onPress={() => onPress(value.id)}
          testID="qa_Modifier_checkbox"
        />
      </View>
      <View style={styles.modifierLeftView}>
        <Text
          accessibilityLabel={`${value.name}, `}
          aria-label={`${value.name}, `}
          style={styles.modifierText}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
          accessible
          testID="qa_ModifierName_txt"
          nativeID="qa_ModifierName_txt"
        >
          {value.name}
        </Text>
        {showCalories && checkValue(value.calories) && (
          <View style={productModifierStyles().checkboxCalorieContainer}>
            <Text
              style={styles.priceText}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
              accessibilityLabel={`${calories}, ${showUnitName}`}
              aria-label={`${calories}, ${showUnitName}`}
              accessible
              testID="qa_ModifierCal_txt"
              nativeID="qa_ModifierCal_txt"
            >
              {`(${value?.calories} ${showUnitName})`}
            </Text>
          </View>
        )}
      </View>
      <View style={productModifierStyles().checkboxCalorieContainer}>
        {price !== null && (
          <Text
            accessibilityLabel={`${price}, `}
            aria-label={`${price}, `}
            style={styles.calorieText}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
            accessible
            testID="qa_ModifierPrice_txt"
            nativeID="qa_ModifierPrice_txt"
          >
            {price}
          </Text>
        )}
      </View>
    </View>
  );
}
export function getCounterText(value, FREE_TEXT_MAX_LENGTH): string {
  return `${value?.length || 0}/${FREE_TEXT_MAX_LENGTH}`;
}

export function recentOrderButtonStyle(): RecentOrdersButtonStylesDescriptor {
  return StyleSheet.create({
    marginStyle: {
      marginTop: 0,
      marginBottom: 0,
    },
    recentOrderText: {
      color: Styles.black,
      fontSize: Styles.Fonts.f7,
      fontFamily: Styles.FontFamily.latoRegular,
      fontWeight: '400',
    },
    textUnderline: {
      borderBottomWidth: 1,
      borderBottomColor: Styles.Colors.PayNew.black01,
      width: '100%',
    },
  });
}

export function checkoutBarUI({
  numItems,
  onPress,
  totalAmount,
}: CheckoutBarProps) {
  return (
    <>
      {numItems > 0 && (
        <View
          style={{
            marginHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
            marginBottom: Styles.Spacing.m3 + Styles.Spacing.m2,
            marginTop: Styles.Spacing.m3,
            alignSelf: 'center',
          }}
        >
          <BarButton
            leftIcon={
              <View>
                <CartImage
                  width={24}
                  height={24}
                  color={Styles.Colors.PayNew.black01}
                />
                <View style={styles.badge}>
                  {numItems > 0 && (
                    <Text
                      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
                      style={styles.badgeText}
                    >
                      {numItems}
                    </Text>
                  )}
                </View>
              </View>
            }
            leftText={Localized.Buttons.checkout}
            onPress={onPress}
            buttonViewStyle={{
              width: Platform.OS === 'web' ? '50%' : '100%',
              backgroundColor: Styles.Colors.CompanyKitchen.green,
              justifyContent: 'space-between',
              height: Styles.Heights.touchTargetHeight1 + 2,
            }}
            containerStyle={{
              width: screenWidth,
              alignItems: 'center',
              justifyContent: 'center',
              paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
            }}
            rightText={totalAmount}
            textStyle={{
              fontFamily: Styles.FontFamily.latoRegular,
              color: Styles.Colors.PayNew.black01,
              fontSize: Styles.Fonts.f1,
              fontWeight: '700',
            }}
            testID="qa_Checkout_Btn"
            leftTestID="qa_CartCount_txt"
            rightTestID="qa_CheckoutAmount_txt"
          />
        </View>
      )}
    </>
  );
}

export function requiredModifiersView(name: string): JSX.Element {
  return (
    <View style={productModifierStyles().requiredViewStyles}>
      <Text
        accessible={true}
        accessibilityLabel={`${name} section`}
        aria-label={`${name} section`}
        style={productModifierStyles().titleText}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
      >
        {`${name}*`}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Styles.Colors.CompanyKitchen.green,
    flexDirection: 'row',
  },
  title: {
    color: Styles.Colors.CompanyKitchen.black,
    fontWeight: '600',
    fontSize: Styles.Fonts.f1,
  },
  content: {
    flexDirection: 'column',
    flex: 1,
    paddingVertical: Styles.Spacing.m2,
    paddingBottom: Styles.Spacing.m3,
    paddingHorizontal: Styles.Spacing.m3,
  },
  description: {
    fontSize: Styles.Fonts.f0,
    color: Styles.Colors.CompanyKitchen.black,
  },
  wrapper: {
    position: 'relative',
    flex: 3,
    flexDirection: 'column',
  },
  itemAddedFeedbackView: {
    position: 'absolute',
    flexDirection: 'row',
    top: Styles.Spacing.m0,
    right: Styles.Spacing.m0,
    left: Styles.Spacing.m0,
    bottom: Styles.Spacing.m0,
  },
  row: {
    flexDirection: 'row',
  },
  cartText: {
    fontSize: Styles.Fonts.f1 * 1.1,
    paddingRight: Styles.Spacing.m2,
    fontWeight: '600',
    color: Styles.Colors.CompanyKitchen.black,
  },
  cart: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    backgroundColor: Styles.Colors.CompanyKitchen.primary,
    alignSelf: 'stretch',
    flexDirection: 'row',
    color: Styles.Colors.CompanyKitchen.primary,
    paddingVertical: Styles.Spacing.m2 + PixelRatio.getFontScale() * 1.3,
    paddingHorizontal: Styles.Spacing.m3,
  },
  dummy: {
    backgroundColor: Styles.Colors.CompanyKitchen.green,
    paddingTop: Styles.Spacing.m1,
    bottom: Styles.Spacing.m0,
    left: Styles.Spacing.m0,
    zIndex: 1,
    paddingBottom: Styles.Spacing.m3,
    paddingLeft: Styles.Spacing.m1,
    position: 'absolute',
    right: Styles.Spacing.m0,
    top: Styles.Spacing.m0,
  },
  badge: {
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    right: Styles.Spacing.m0,
    top: Styles.Spacing.m0,
    bottom: Styles.Spacing.m1 + 2,
    left: Styles.Spacing.m0,
    zIndex: 1,
  },
  badgeText: {
    fontSize: Styles.Fonts.f0,
    fontWeight: 'bold',
    fontFamily: Styles.FontFamily.latoRegular,
    color: Styles.Colors.CompanyKitchen.green,
  },
  calorieSectionView: {
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'flex-end',
  },
  requiredText: {
    fontStyle: 'italic',
    fontSize: Styles.Fonts.f1,
    color: Styles.dangerColor,
  },
  modifierLeftView: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginLeft: Styles.Spacing.m2 + 2,
  },
  calorieText: {
    fontFamily: Styles.FontFamily.latoRegular,
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    color: Styles.Colors.PayNew.black01,
    textAlign: 'right',
  },
  modifierText: {
    fontSize: Styles.Fonts.f1,
    fontFamily: Styles.FontFamily.latoRegular,
    fontWeight: '400',
    color: Styles.Colors.PayNew.black01,
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    maxWidth: '65%',
  },
  priceText: {
    fontFamily: Styles.FontFamily.latoRegular,
    fontSize: Styles.Fonts.f1,
    color: Styles.Colors.PayNew.black01,
    fontWeight: '400',
    marginLeft: Styles.Spacing.m1,
  },
});

export function getActiveIconColor() {
  return Styles.Colors.CompanyKitchen.black;
}
export function getInActiveIconColor() {
  return Styles.Colors.CompanyKitchen.black;
}

export function getMenuListCompnentsFontFamily() {
  return Styles.FontFamily.latoRegular;
}

export function recentOrdersHideDetailsColors() {
  return Styles.Colors.CompanyKitchen.black;
}

export function numberOfColumnsFlatlist() {
  return 1;
}

export function subMenuStyles() {
  return StyleSheet.create({
    container: {
      flex: 1,
      marginBottom: Styles.Spacing.m3 + Styles.Spacing.m2,
    },
  });
}

export function getModifierPrice(price, props) {
  if (price !== null || price > 0) {
    return `${formatCurrency(props, price, AccountStore.getCurrency())}`;
  }
}

export function customisedCalorieSection() {
  return null;
}

export function calorieColor() {
  return Styles.Colors.PayNew.darkHuesBase03;
}
export function pointsFontSize() {
  return Styles.Fonts.f0;
}
export function rewardsLabelSize(): number {
  return Styles.Fonts.f0;
}

export function rewardsLabelColor(): string {
  return Styles.Colors.Canteen.green;
}

export default {
  customTilesButtonStyles,
  pickupLocationListStyles,
  recentOrderButtonStyle,
  productModifierStyles,
  radioButtonProductModifier,
  checkboxProductModifiers,
  getCounterText,
  checkoutBarUI,
  requiredModifiersView,
  pickupLocationInnerCircleBackgroundColor,
  pickupLocationOuterCircleBorderColor,
  getActiveIconColor,
  getInActiveIconColor,
  getMenuListCompnentsFontFamily,
  recentOrdersHideDetailsColors,
  numberOfColumnsFlatlist,
  subMenuStyles,
  getModifierPrice,
  customisedCalorieSection,
  calorieColor,
  pointsFontSize,
  rewardsLabelSize,
  rewardsLabelColor,
};
